import angular from 'angular';
import homeComponent from './home.component';

let homeModule = angular.module('home', [])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('home', {
      url: '/cms/username/:username/password/:password/uoid/:uoid',
      component: 'home'
    })
})

.component('home', homeComponent)

.name;

export default homeModule;



// WEBPACK FOOTER //
// ./client/app/pages/home/home.js